import { Component } from '@angular/core';

@Component({
  templateUrl: 'editagent.component.html'
})
export class EditagentComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/editagent.component.ts